module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"type":"типу ТС","organization":"организации","filter":"Фильтровать по:","reset":"Сбросить","apply":"Применить","choose":"Выберите из списка"},"en":{"type":"Transport type","organization":"Organization name","filter":"Filter by:","reset":"Reset","apply":"Apply","choose":"Choose from the list"}}')
  delete Component.options._Ctor
}
